export default __webpack_public_path__ + "static/media/MY TREE (2).2883676f.png";